/* eslint-disable jsx-a11y/media-has-caption */

import React from 'react';
import PropTypes from 'prop-types';
import Lottie from 'react-lottie';

import HeroBanner from './HeroBanner';
import StyledInput from '../StyledInput';
import AbsoluteAsset from '../AbsoluteAsset';

import * as animationData from './lottie.json';
import './hero.scss';

const Hero = ({ data }) => (
  <React.Fragment>
    <div className="anchor" id="Home" />
    <div className="abs-asset-holder">
      <div className="container-wrapper">
        <div className="container">
          <div className="hero">
            <div className="hero__textbox">
              <HeroBanner
                data={data.headline_phrases}
              />
              <h1 className="subtitle">{ data.headline_suffix }</h1>
              <h3>{ data.location }<span className="separator">&nbsp;•&nbsp;</span>{ data.date }</h3>
              <a href="https://mlh.io/" target="_blank" rel="noopener noreferrer">
                <img className="hero__mlh" src="/images/mlh.png" alt="MLH 2019" />
              </a>
              <div>
                <a href="https://hackthenorth2018.devpost.com/submissions" target="_blank" rel="noopener noreferrer"><button className="cta-button secondary">{data.buttons.submissions}</button></a>
              </div>
            </div>
            <div className="hero__video">
              { typeof Lottie === 'object' ? null : <Lottie
                options={{
                  loop: true,
                  autoplay: true,
                  animationData,
                }}
                height="100%"
                width="100%"
              /> }
            </div>
          </div>
          <div className="center">
            <StyledInput
              data={data.sign_up_input}
            />
          </div>
          { /* <div className="center about-margin">
            <a href={data.sponsor_cta.link}>{data.sponsor_cta.text}</a>
            </div> */ }
          <a href="https://mlh.io/" target="_blank" rel="noopener noreferrer">
            <img className="hero__mlh mobile" src="/images/mlh.png" alt="" />
          </a>
        </div>
      </div>
      <AbsoluteAsset className="e53 e5--hero1" src="/assets/e53.png" />
      <AbsoluteAsset className="e52 e5--hero3" src="/assets/e52.png" />
    </div>
  </React.Fragment>
);

Hero.propTypes = {
  data: PropTypes.shape({
    date: PropTypes.string,
    headline_phrases:
      PropTypes.arrayOf(PropTypes.shape({
        phrase: PropTypes.string,
        speaker: PropTypes.string,
        colour: PropTypes.string,
      })),
    sponsor_cta: PropTypes.shape({
      text: PropTypes.string,
      link: PropTypes.string,
    }),
    headline_suffix: PropTypes.string,
    slogan: PropTypes.string,
    location: PropTypes.string,
    sign_up_input: PropTypes.shape({
      cta: PropTypes.string,
      label: PropTypes.string,
      palceholder: PropTypes.string,
    }),
  }).isRequired,
};

export default Hero;



// WEBPACK FOOTER //
// ./src/components/Hero/index.jsx